import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { media } from '~layout';
var ModalBody = styled.div.withConfig({
  displayName: "ModalBody",
  componentId: "sc-13pcilj-0"
})(["padding:", " ", " ", ";", " ", " ", ""], rem(16), rem(24), rem(16), media.md(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        padding-left: ", ";\n        padding-right: ", ";\n    "])), rem(32), rem(32)), function (_ref) {
  var $isContentCover = _ref.$isContentCover;
  return $isContentCover && css(["@media (min-width:0){padding:0;}"]);
}, function (_ref2) {
  var hasDefaultFooter = _ref2.hasDefaultFooter;
  return !hasDefaultFooter && css(["@media (min-width:0){padding-bottom:", ";}"], rem(16));
});
export default ModalBody;